import { render, staticRenderFns } from "./ProfileStep.vue?vue&type=template&id=3951ed3b&scoped=true"
import script from "./ProfileStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProfileStep.vue?vue&type=style&index=0&id=3951ed3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951ed3b",
  null
  
)

export default component.exports